<div class="row g-0 bottom-border">
  <div class="col-lg-9 offset-lg-1 col-12 label-align">
    <span class="p3 separator-label">{{label}}</span>
  </div>
</div>